module.exports = __webpack_public_path__ + "static/media/digital_desa_rohil.c9f06eb3.png";